export default __webpack_public_path__ + "static/media/wodka-agency.058c231f.svg";